export default __webpack_public_path__ + "static/media/logo.20b3c28a.png";